const pages = [
    {
        links: ['', undefined],
        name: 'index',
    },
] as const;

export default pages;
